import { Suspense } from 'react'

import type { RouteObject } from 'react-router'
import { Outlet } from 'react-router-dom'

export const memberSettingsRoutes: RouteObject = {
  path: 'settings/*',
  async lazy() {
    const { MemberSettingsRouteGuard } = await import(
      '../client/components/Settings/MemberSettingsRouteGuard.js'
    )
    const { SettingsLayout } = await import(
      '../client/components/Settings/SettingsLayout.js'
    )

    return {
      element: (
        <MemberSettingsRouteGuard>
          <SettingsLayout>
            <Suspense fallback={<></>}>
              <Outlet />
            </Suspense>
          </SettingsLayout>
        </MemberSettingsRouteGuard>
      ),
    }
  },
  children: [
    {
      path: 'account',
      async lazy() {
        const { AccountSettings } = await import(
          '../client/components/Settings/AccountSettings.js'
        )

        return { Component: AccountSettings }
      },
    },
    {
      path: 'security',
      async lazy() {
        const { SecuritySettings } = await import(
          '../client/components/Settings/SecuritySettings.js'
        )

        return { Component: SecuritySettings }
      },
    },
    {
      path: 'notifications',
      async lazy() {
        const { NotificationSettings } = await import(
          '../client/components/Settings/Notifications/NotificationSettings.js'
        )

        return { Component: NotificationSettings }
      },
    },
    {
      path: 'appearance',
      async lazy() {
        const { ColorSchemeSettings } = await import(
          '../client/components/Settings/ColorSchemeSettings.js'
        )

        return { Component: ColorSchemeSettings }
      },
    },
    {
      path: 'connected-apps',
      async lazy() {
        const { MemberConnectedApps } = await import(
          '../client/components/Settings/MemberConnectedApps/index.js'
        )

        return { Component: MemberConnectedApps }
      },
    },
  ],
}
